export function convertDateStringToUTC(date: string | number): number | null {
  if (!date) return null;

  if (typeof date === 'number') {
    return date;
  }

  const [year, month, day] = date.split('-').map(Number);

  return Date.UTC(year, month - 1, day);
}
